import { Outlet } from "react-router-dom";
import { ToastHost } from "@/components/ui/Toast";
import { useNativeBack } from "./back";

/**
 * Owns the viewport height for every screen, so a page's `<main>` fills what is
 * left below the header instead of claiming a full viewport of its own. Pages
 * sizing themselves added up to header + 100dvh and scrolled a screenful of
 * empty space whenever `<ScreenHeader />` drew anything.
 */
export function AppLayout() {
  useNativeBack();
  return (
    <div className="flex min-h-dvh flex-col">
      <Outlet />
      <ToastHost />
    </div>
  );
}
